module.exports = __webpack_public_path__ + "static/media/bg5.d6730522.jpg";